module.exports = __webpack_public_path__ + "img/slot_rich.d15b6fad.png";